import React from 'react';
import styled from '@emotion/styled';

interface MessageProps {
  text: string;
  type: 'success' | 'error' | 'info';
  onClose?: () => void;
}

const MessageContainer = styled.div<{ type: string }>`
  position: fixed;
  top: 20px;
  right: 20px;
  padding: 12px 24px;
  border-radius: 4px;
  background-color: ${props => 
    props.type === 'success' ? '#4caf50' :
    props.type === 'error' ? '#f44336' :
    '#2196f3'};
  color: white;
  box-shadow: 0 2px 5px rgba(0, 0, 0, 0.2);
  z-index: 1000;
  display: flex;
  align-items: center;
  justify-content: space-between;
  min-width: 200px;
  max-width: 400px;
`;

const CloseButton = styled.button`
  background: none;
  border: none;
  color: white;
  cursor: pointer;
  font-size: 16px;
  margin-left: 16px;
  padding: 0;
  
  &:hover {
    opacity: 0.8;
  }
`;

const Message: React.FC<MessageProps> = ({ text, type, onClose }) => {
  return (
    <MessageContainer type={type}>
      <span>{text}</span>
      {onClose && (
        <CloseButton onClick={onClose}>&times;</CloseButton>
      )}
    </MessageContainer>
  );
};

export default Message; 